import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from './api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const token = localStorage.getItem('quizzler_host_token');
    if (token) {
      authAPI.getMe()
        .then((response) => {
          setUser(response.data.host);
        })
        .catch(() => {
          localStorage.removeItem('quizzler_host_token');
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login(email, password);
    localStorage.setItem('quizzler_host_token', response.data.token);
    setUser(response.data.host);
    return response.data;
  };

  const signup = async (email, password, name) => {
    const response = await authAPI.signup(email, password, name);
    localStorage.setItem('quizzler_host_token', response.data.token);
    setUser(response.data.host);
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('quizzler_host_token');
    setUser(null);
  };

  const value = {
    user,
    loading,
    login,
    signup,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
